import { FileActions } from "./FileActions";
import { formatBytes } from "utils/formatBytes";
import { UploadProgress } from "./UploadProgress";
import { UploadedFile } from "../types/UploadedFile.type";

interface FileCardProps {
	file: UploadedFile;
	progress?: number;
	isUploading?: boolean;
	error?: Error | null;
	isPreview?: boolean;
	onDelete: () => void;
	onCancel?: () => void;
	onRetry?: () => void;
}

/**
 * Displays the uploaded file, or pending uploaded file
 * @param param0
 * @returns
 */
export const FileCard: React.FC<FileCardProps> = ({
	file,
	progress = 0,
	isUploading = false,
	error,
	isPreview,
	onDelete,
	onCancel,
	onRetry,
}) => {
	return (
		<div className="group my-3 flex items-center justify-between rounded-lg border p-3">
			<div className="flex flex-col">
				<span className="break-all text-sm font-semibold">{file.name}</span>
				{file.size && (
					<span className="text-xs text-gray-500">
						{formatBytes(file.size)}
					</span>
				)}
			</div>

			<div className="flex items-center gap-3">
				{isUploading && (
					<UploadProgress
						progress={progress}
						error={!!error}
						onRetry={onRetry}
					/>
				)}

				<FileActions
					hasErrored={!!error}
					isPreview={isPreview}
					isUploading={isUploading}
					filePath={file.path}
					fileName={file.name}
					onCancel={onCancel}
					onDelete={onDelete}
					onRetry={onRetry}
				/>
			</div>
		</div>
	);
};
